<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_terms.png')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2026年10月12日
        </h2>

        <h3 class="terms-title">
          1.&#12288;総則および基本事項
        </h3>
        <h4 class="terms-subtitle">
          1.1&#12288;本規約の効力および運営情報
        </h4>
        <p class="terms-clause">
          1.1.1&#12288;{{ brandName }}（以下「当サイト」といいます）に登録するすべてのお客様は、本利用規約（以下「本規約」といいます）に同意する必要があります。本規約および本規約において明示的に参照される文書は、当サイトとお客様との間の完全な合意を構成し、両者の契約関係を規定します。当サイトを利用する前に、本規約を十分に読み、その内容を理解してください。本規約に同意しない場合は、当サイトを利用せず、または利用を継続しないでください。併せて、当サイトのプライバシーポリシーについても十分に理解したうえで利用することを推奨します。
        </p>
        <p class="terms-clause">
          1.1.2&#12288;当サイトは、ライセンス番号15679に基づき、コモロ連合アンジュアン自治島政府の規制下で運営されています。当サイトは、賭博およびゲームの運営に必要な法的権限を有し、適用される規制上の要件を遵守して運営されます。
        </p>
        <p class="terms-clause">
          1.1.3&#12288;当サイトは、Initial Singularity Limited（以下「運営会社」といいます）が所有し、運営します。
        </p>
        <p class="terms-clause">
          1.1.4&#12288;登録番号：15679 登録住所：Hamchako, Mutsamudu, Autonomous Island of Anjouan, Union of Comoros
        </p>
        <h4 class="terms-subtitle">
          1.2&#12288;利用資格および基本的義務
        </h4>
        <p class="terms-clause">
          1.2.1&#12288;本規約に同意し、当サイトにアカウント（以下「アカウント」といいます）を登録することにより、お客様は、次の各事項を表明し、保証するものとします。
        </p>
        <p class="terms-clause terms-clause-item">
          1.2.1(a)&#12288;お客様自身の名義でアカウントを登録すること。
        </p>
        <p class="terms-clause terms-clause-item">
          1.2.1(b)&#12288;アカウント番号、パスワードその他のアクセス手段を含むすべてのアカウント情報を適切に管理し、その管理について単独で責任を負うこと。不正アクセスまたはアカウント侵害が疑われる場合は、直ちに当サイトへ連絡し、アカウントおよび残高の不正利用を防止するために必要な措置を講じること。
        </p>
        <p class="terms-clause terms-clause-item">
          1.2.1(c)&#12288;満20歳以上であること。20歳未満の方によるカジノの利用は禁止され、違反が確認された場合、当該アカウントは直ちに閉鎖されること。
        </p>
        <p class="terms-clause terms-clause-item">
          1.2.1(d)&#12288;アカウントは、お客様1人につき1つに限り、同一のIPアドレスまたはデバイスから登録できるアカウントも1つのみとします。また、1世帯につき1アカウントに限られます。お客様による複数アカウントの開設、保有またはその試みが確認された場合、当サイトはその裁量により、該当するアカウントの一部または全部をブロックし、閉鎖し、もしくは終了することができます。この場合、決済済みか未決済かを問わず、該当アカウントで行われたすべての賭けを取り消し、または無効とし、出金可能な資金を没収し、または返金する場合があります。
        </p>
        <p class="terms-clause terms-clause-item">
          1.2.1(e)&#12288;他者を代理せず、お客様自身の立場で、自己の娯楽および楽しみの目的に限り当サイトを利用すること。
        </p>
        <p class="terms-clause terms-clause-item">
          1.2.1(f)&#12288;一部の法域では、当サイトへのアクセスまたは当サイトの利用が違法とされる場合があることを理解すること。
        </p>
        <h4 class="terms-subtitle">
          1.3&#12288;本規約の変更
        </h4>
        <p class="terms-clause">
          1.3.1&#12288;当サイトは、適用される法令、規制その他の要件を遵守するために必要な場合を含め、本規約をいつでも変更する権利を有します。
        </p>
        <p class="terms-clause">
          1.3.2&#12288;本規約に重大な変更を行う場合、当サイトは当サイト上に通知を掲載します。お客様が変更後の本規約に同意しない場合、当サイトはお客様のアカウントを閉鎖します。この場合、有効なアカウント残高の出金を希望するお客様は、カスタマーサービスへ連絡する必要があります。
        </p>

        <h3 class="terms-title">
          2.&#12288;アカウント登録、管理およびセキュリティ
        </h3>
        <h4 class="terms-subtitle">
          2.1&#12288;アカウントの作成および個人情報
        </h4>
        <p class="terms-clause">
          2.1.1&#12288;アカウントを作成するには、携帯電話番号、パスワードその他の個人情報を入力する必要があります。登録完了後、氏名、生年月日、住所その他の情報を追加で入力していただきます。
        </p>
        <p class="terms-clause">
          2.1.2&#12288;アカウントに登録する氏名および住所は、提出する身分証明書その他の確認書類に記載された情報と一致していなければなりません。また、身分証明書に記載された住所は、住所確認書類の記載と一致している必要があります。当サイトは、本人確認のため、パスポート、身分証明書、住所確認書類、有効期限内の利用可能なクレジットカードその他の本人確認書類の提出を、いつでも求めることができます。お客様がこれらの書類を提出しない場合、当サイトはアカウントを一時的に閉鎖することができます。
        </p>
        <p class="terms-clause">
          2.1.3&#12288;お客様は、登録時に正確な個人情報を入力し、登録情報に変更が生じた場合は速やかに更新しなければなりません。これらの義務を怠った場合、当サイトは、アカウントの閉鎖もしくは利用制限、または入金額（ボーナスを含みます）の無効化その他の措置を講じることがあります。また、当サイトは、理由の如何を問わず、いかなる者についてもアカウントの開設を拒否する権利を留保します。
        </p>
        <h4 class="terms-subtitle">
          2.2&#12288;地域制限およびVPN
        </h4>
        <p class="terms-clause">
          2.2.1&#12288;VPN、プロキシサーバーその他の手段を用いて実際の位置情報を隠す行為は禁止します。お客様が禁止地域から当サイトにアクセスしていると当サイトが判断した場合、当サイトは事前の通知なく、直ちにアカウントを閉鎖することができます。
        </p>
        <p class="terms-clause">
          2.2.2&#12288;次の国または地域（以下「禁止地域」といいます）に居住するお客様は、当サイトを利用できません。米国およびその属領、マカオ、スイス、アイルランド、シンガポール、ハンガリー、ミャンマー、ルーマニア、ベルギー、デンマーク、フィンランド、ドイツ、イラン、イラク、イタリア、ミクロネシア、ノルウェー、ポーランド、サウジアラビア、オランダ、プエルトリコ、英国、フランス、香港、台湾、北朝鮮、イスラエル、キプロス、エストニア、フィリピン、トルコ、スペイン、ブルガリア、アンティグア・バーブーダ、キュラソー、ならびに法律または地域の条例によりオンラインカジノが禁止されているその他の国または地域。
        </p>
        <h4 class="terms-subtitle">
          2.3&#12288;ログイン情報、本人確認およびマネーロンダリング防止
        </h4>
        <p class="terms-clause">
          2.3.1&#12288;お客様は、当サイトへのログインに使用するアカウント名およびパスワードを設定し、これらのログイン情報を安全に管理しなければなりません。ログイン情報を第三者に開示してはなりません。当サイトは、開示が意図的か否か、または積極的か受動的かを問わず、ログイン情報が第三者に開示されたことにより生じたアカウントの不正利用について責任を負いません。お客様のログイン情報を使用して行われた行為は、お客様自身の行為とみなし、その結果についてはお客様が責任を負うものとします。ログイン情報が第三者に知られた場合、お客様は直ちに当サイトへ通知し、速やかにログイン情報を変更しなければなりません。
        </p>
        <p class="terms-clause">
          2.3.2&#12288;当サイトは、理由の如何を問わず、いつでもお客様の身元を確認し、関連書類の提出を求めることができます。確認には、法令で許される範囲の身元調査、信用調査および個人履歴調査が含まれますが、これらに限られません。調査内容は状況に応じて異なり、氏名、住所、年齢、職業、財務状況や資金源を含む金融取引、登録情報およびゲーム活動記録等を確認する場合があります。当サイトは、調査中であることをお客様へ通知する義務を負いません。また、調査のため、認可を受けた信用照会機関、身元確認サービス、不正防止機関その他の第三者企業を利用することがあります。本人確認もしくは調査の結果に問題がある場合、または必要な確認を完了できない場合、当サイトはその裁量により、アカウントを閉鎖し、決済済みのすべての賭けを取り消し、アカウント残高を保留することができます。個人情報は、当サイトのプライバシーポリシーに従って取り扱います。
        </p>
        <p class="terms-clause">
          2.3.3&#12288;当サイトは、マネーロンダリングを防止するため、すべての支払い取引を監視します。当サイトおよび規制・監督機関は、犯罪防止を目的として、取引の監視または調査を求めることがあります。当サイトは、疑わしい取引を関係当局へ報告します。また、当サイトのゲームに関連する不審な行為を発見した場合、当サイトは直ちに関係当局へ報告し、適用されるマネーロンダリング防止法およびテロ資金供与対策法に従い、アカウントの凍結もしくは閉鎖、決済済みの賭けの取消し、またはアカウント残高の保留を行うことがあります。
        </p>
        <p class="terms-clause">
          2.3.4&#12288;当サイトは、マネーロンダリング等を防止するため、必要に応じて、お客様に収入を証明する書類の提出を求めることがあります。
        </p>
        <h4 class="terms-subtitle">
          2.4&#12288;アカウント履歴、誤入金および休止アカウント
        </h4>
        <p class="terms-clause">
          2.4.1&#12288;お客様は、アカウントにログインすることにより、入出金、報酬およびゲームの記録を含むアカウント履歴をいつでも確認できます。誤りを発見した場合は、当サイトが調査および修正を行えるよう、直ちにカスタマーサービスへ連絡しなければなりません。
        </p>
        <p class="terms-clause">
          2.4.2&#12288;入出金、報酬、残高その他のアカウント履歴の記録に誤り、不一致または身に覚えのない取引がある場合、お客様は、対象となる取引または残高変動が発生した日から24時間以内にカスタマーサービスへ申告しなければなりません。当該期間の経過後に行われた申告については、法令上対応が義務付けられる場合を除き、当サイトはこれを受け付けず、調査、記録もしくは残高の修正もしくは再計算、返金またはその他の補償を一切行いません。
        </p>
        <p class="terms-clause">
          2.4.3&#12288;クレジット、ボーナスその他の資金が誤ってアカウントに入金された場合、お客様はメールまたはチャットにより直ちに当サイトへ報告しなければなりません。誤って入金された金額はすべて当サイトに帰属し、お客様は当該金額をアカウントから速やかに返金する義務を負います。お客様が誤入金された資金を出金した場合、お客様は当サイトに対して当該出金額の返済義務を負い、直ちに返済しなければなりません。また、誤って入金されたポイント、ボーナスその他の資金を使用して行われた賭けは、すべて無効とします。
        </p>
        <p class="terms-clause">
          2.4.4&#12288;12か月間連続して取引がないアカウントは、休止状態とみなします。当サイトは、休止状態となる日の少なくとも1か月前に、お客様へメールで通知します。お客様は、アカウントへログインすることにより休止状態を解除し、利用を再開できます。休止状態となった後、当サイトがお客様と連絡を取れない場合、当サイトは、アカウント残高の5％または月額150円のいずれか高い額を管理手数料として徴収します。この手数料により、アカウント残高がゼロになる場合があります。手数料の返金を求める場合、お客様は、休止期間中の健康上の不調その他の正当な理由を証明する書類を提出する必要があります。アカウント残高には、その金額にかかわらず利息は付されません。お客様は、当サイトを金融機関とみなすことはできません。
        </p>

        <h3 class="terms-title">
          3.&#12288;禁止行為、調査および不正利用
        </h3>
        <h4 class="terms-subtitle">
          3.1&#12288;詐欺、共謀およびアカウント間の資金移動
        </h4>
        <p class="terms-clause">
          3.1.1&#12288;当サイトは、詐欺および共謀行為を厳格に禁止します。ゲーム内で直接または間接に他のプレイヤーと共謀する行為も、これに含まれます。詐欺または共謀行為が行われたと合理的に判断した場合、当サイトは、当該行為に関連する賭けを取り消し、適切な措置を講じ、またはアカウント内のすべての資金を没収したうえでアカウントを閉鎖することができます。これによりお客様または他のプレイヤーに生じた損失について、当サイトは一切の責任を負いません。他のお客様またはプレイヤーが詐欺、共謀その他の犯罪行為を行っていると疑う合理的な理由がある場合、お客様はメールまたはチャットにより直ちに当サイトへ報告しなければなりません。
        </p>
        <p class="terms-clause">
          3.1.2&#12288;他のお客様のアカウントへ資金を送金し、または他のお客様のアカウントから資金を受け取る行為は禁止します。
        </p>
        <h4 class="terms-subtitle">
          3.2&#12288;不正侵入、コード改変、脆弱性および自動化ツール
        </h4>
        <p class="terms-clause">
          3.2.1&#12288;お客様は、当サイトへの不正侵入、当サイトのコードの改変、バグもしくは脆弱性の悪用、ハッキング、コンピューター攻撃、詐欺その他の不正行為、ならびにボット、自動化プログラム、機械的もしくは電子的な機器その他の不正なツールを、お客様自身または第三者による当サイトの利用に用いてはなりません。当サイトが、これらの機器、ツール、またはお客様に不当な利益を与える目的で設計された外部リソースが利用されたと合理的に判断した場合、これらの手段により行われたすべての賭けを無効とし、調査中のアカウントを一時的に凍結し、または閉鎖することができます。当サイトは、これらの行為を詐欺とみなし、アカウント残高を返金することなくアカウントを閉鎖する権利を留保します。
        </p>
        <h4 class="terms-subtitle">
          3.3&#12288;取引記録およびイベント参加資格
        </h4>
        <p class="terms-clause">
          3.3.1&#12288;当サイトは、いつでも取引記録およびゲーム記録を確認することができます。調査の結果、不正な方法でゲームが行われたと判断した場合、当サイトはその裁量により、お客様に付与した報酬、ボーナスおよびリベートを取り消すことができます。
        </p>
        <p class="terms-clause">
          3.3.2&#12288;お客様が、本来受領できる額を超えるボーナスを得る目的で、イベントまたはプロモーションにおいて本規約3.1.1、3.2.1または3.4.1に定める不正行為を行った場合、当サイトは、お客様について、以後すべてのイベントおよびプロモーションへの参加資格を直ちに取り消します。
        </p>
        <h4 class="terms-subtitle">
          3.4&#12288;その他の規約違反行為
        </h4>
        <p class="terms-clause">
          3.4.1&#12288;次の行為が確認された場合、当サイトは本規約への違反とみなし、必要な措置を講じます。
        </p>
        <p class="terms-clause terms-clause-item">
          3.4.1(a)&#12288;第三者に情報を不正に開示する行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.4.1(b)&#12288;不正にコピーされ、または利用されたクレジットカードもしくはデビットカードを使用して賭けを行う行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.4.1(c)&#12288;当サイトのイベントまたはプロモーションを濫用する行為
        </p>
        <h4 class="terms-subtitle">
          3.5&#12288;出金条件等の回避、低リスクプレイおよびゲーム機能の操作
        </h4>
        <p class="terms-clause">
          3.5.1&#12288;「低リスクプレイ」とは、単一または一連のベットを通じて、損失、価格変動またはゲーム結果に伴う実質的なリスクを意図的に軽減、相殺し、または他のゲーム、アカウントもしくは取引へ移転しながら、4.1.7に定める賭け条件その他の出金条件もしくは資金利用条件の形式的な達成、または不当な利益の取得を図る行為をいいます。
        </p>
        <p class="terms-clause">
          3.5.2&#12288;現金ウォレットの残高を利用したプレイであるか否かを問わず、次の各行為は禁止します。
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.2(a)&#12288;ルーレットにおける赤および黒、バカラにおけるプレイヤーおよびバンカーその他相反する結果へ同時または連続してベットすることにより、損失リスクを相殺する行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.2(b)&#12288;単一または複数のゲームにおいて、結果の大部分を実質的にカバーするベット、ヘッジベットその他損失または価格変動を著しく抑える組合せを行う行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.2(c)&#12288;一のゲームで高倍率または高額の勝利を得た後、出金条件等を形式的に達成することを主たる目的として、高RTP、低ボラティリティその他損失リスクが相対的に低いゲームへ直ちにまたは反復して移行する行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.2(d)&#12288;複数のアカウント、第三者、デバイス、決済手段または関連するベットを組み合わせることにより、損失リスクを軽減もしくは相殺し、または利益を移転する行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.2(e)&#12288;ゲームの賭け条件への反映方法、決済方法、払戻し方法その他の仕組みを利用して、実質的なリスクを負うことなく出金条件等の達成を図る行為
        </p>
        <p class="terms-clause">
          3.5.3&#12288;「ゲーム内価値」とは、フリースピン、ボーナスラウンド、CollectもしくはCash Out機能、メーター、ゲージ、ポイント、累積進捗、リスピン、再抽選、ジャックポット進捗、未決済のゲームラウンドその他後に実行、決済、回収または資金化することができるゲーム上の状態または権利をいいます。
        </p>
        <p class="terms-clause">
          3.5.4&#12288;資金またはゲーム内価値をゲーム内に保持し、追加の入金、ウォレット振替、出金申請、出金条件等の達成その他アカウント残高もしくは資金の取扱いが変更される事由の前後をまたいで、その実行、決済または回収の時期を意図的に操作する行為は禁止します。これには、次の各行為が含まれます。
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.4(a)&#12288;ゲームラウンドまたはゲーム内機能を意図的に完了させず、追加の入金、ウォレット振替、出金申請または出金条件等の達成後に完了させる行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.4(b)&#12288;ストック型ゲームその他のゲームで形成したゲーム内価値を保持し、資金の出所または適用条件が変更された後に実行、決済または回収する行為
        </p>
        <p class="terms-clause terms-clause-item">
          3.5.4(c)&#12288;ゲーム内に資金または価値を隠し、当該資金または価値を考慮せずに入金、出金または残高の移動を行った後、これを回収する行為
        </p>
        <p class="terms-clause">
          3.5.5&#12288;特定のゲームを利用した事実、当該ゲームのRTPが高いこと、またはプレイ中にゲームを変更した事実のみをもって、直ちに本条違反と判断するものではありません。
        </p>
        <p class="terms-clause">
          3.5.6&#12288;当サイトは、本条違反の有無を判断するにあたり、個別のベットのみではなく、ベットの順序、金額、倍率、RTP、ボラティリティ、ゲーム間の移行時期、ゲーム内価値の形成および回収時期、入出金およびウォレット振替の履歴、関連アカウント、デバイス、IPアドレス、決済手段、行為の反復性ならびに経済的な結果を含む一連の取引およびプレイを総合的に考慮します。
        </p>
        <p class="terms-clause">
          3.5.7&#12288;当サイトが合理的な根拠に基づき本条違反を疑う場合、調査が完了するまで、関連する賭けもしくは取引の決済、出金申請、資金の移動またはアカウント機能の全部もしくは一部を一時的に制限し、必要な説明、本人確認書類、資金源に関する資料その他の情報の提出を求めることができます。
        </p>
        <p class="terms-clause">
          3.5.8&#12288;違反が軽微であり、不当な利益が生じていないと当サイトが合理的に判断した場合、当サイトは、警告、対象となるベットの出金条件等への不算入、追加の賭け条件の設定その他違反の性質および影響に応じた措置を講じることができます。
        </p>
        <p class="terms-clause">
          3.5.9&#12288;違反が故意であり、または不当な利益が生じたと当サイトが合理的に判断した場合、当サイトは、違反に関連するベットもしくは取引の取消し、当該ベットもしくは取引から生じた利益の無効化、違反がなかった場合の状態への残高の再計算、出金申請の取消し、プロモーション参加資格の一時的もしくは恒久的な停止、またはアカウント機能の制限を行うことができます。
        </p>
        <p class="terms-clause">
          3.5.10&#12288;違反が重大、反復的、組織的もしくは詐欺的である場合、または複数アカウント、第三者との共謀、虚偽情報もしくは不正な決済手段が利用された場合、当サイトは、3.5.9に定める措置に加え、アカウントを停止もしくは閉鎖し、適用法令、マネーロンダリング防止義務その他の規制上の要件に従って、関係機関またはサービス提供者へ必要な情報を提供することができます。
        </p>
        <p class="terms-clause">
          3.5.11&#12288;お客様が適法に入金し、本条違反と直接関係しない入金元本は、本条違反のみを理由として当然に没収されるものではありません。ただし、当該元本が詐欺、第三者決済、支払取消し、違法取引、マネーロンダリングその他の不正行為に関連する場合、または違反がなかった場合の状態へ残高を戻すために必要な範囲については、この限りではありません。
        </p>
        <h4 class="terms-subtitle">
          3.6&#12288;不適切な言動および連絡対応の制限
        </h4>
        <p class="terms-clause">
          3.6.1&#12288;お客様が、場所を問わず、当サイトに関係する者に対し、攻撃的、誹謗中傷的、侮辱的その他不快な発言または行動をした場合、当サイトはその判断により、アカウントを停止し、または制限することができます。この場合、当サイトは、以後のチャットまたはメールへの対応を中止することがあります。
        </p>

        <h3 class="terms-title">
          4.&#12288;入金、出金および決済
        </h3>
        <h4 class="terms-subtitle">
          4.1&#12288;決済方法、本人名義、入金目的および出金条件
        </h4>
        <p class="terms-clause">
          4.1.1&#12288;お客様は、アカウントへの入出金に、正当な金融機関が発行した本人名義の有効なクレジットカードもしくは口座、またはその他の正規の支払い方法のみを使用するものとします。支払い名義がお客様本人のものではないと当サイトが判断した場合、当サイトは、アカウントを閉鎖し、すべての勝利金を無効とし、当該カードの利用を禁止することができます。
        </p>
        <p class="terms-clause">
          4.1.2&#12288;お客様がアカウントから資金を出金するには、所定の最低入金額以上の入金を行い、本人確認（KYC）を完了する必要があります。
        </p>
        <p class="terms-clause">
          4.1.3&#12288;当サイトは、出金処理に伴う合理的な手数料を請求することができます。また、当サイトの管理が及ばない外部の銀行手数料が発生する場合があります。出金手数料は、お客様アカウントの「出金」ページに表示します。
        </p>
        <p class="terms-clause">
          4.1.4&#12288;不正な手段で取得された資金は、違法な資金とみなします。当サイトは、適用法令に従い、可能な限り、入金時と同一の資金経路を用いて資金を移動します。入出金は、登録されたアカウント所有者本人の名義でのみ行うことができます。当サイトは、必要に応じて入出金または資金移動を制限し、または特定の支払い方法による出金をお客様に求め、出金を取り消すことができます。
        </p>
        <p class="terms-clause">
          4.1.5&#12288;出金は、原則として、お客様が入金時に選択したものと同一の決済方法により行います。ただし、当サイトが別途認める場合、または当該方法による処理ができない場合を除きます。複数の決済方法により入金された場合、当サイトは、その裁量により、各入金方法に応じて出金額を分割して処理することができます。これらの処理は、マネーロンダリング防止に関する規制および方針に従って行います。
        </p>
        <p class="terms-clause">
          4.1.6&#12288;お客様がクレジットカードまたはデビットカードで入金する場合、当サイトはその裁量により、セキュリティコード（CVV）に加え、カード番号の最初の6桁および最後の4桁を確認できるカード両面の画像の提出を求めることがあります。
        </p>
        <p class="terms-clause">
          4.1.7&#12288;アカウントから資金を出金するには、お客様は、ゲーム内で入金額の少なくとも2倍に相当する金額を賭ける必要があります。当サイトは、賭け金額が不十分であるとその裁量により判断した場合、出金申請の支払いを拒否し、一定の条件のもとで追加の賭けを求めることができます。
        </p>
        <p class="terms-clause">
          4.1.8&#12288;お客様のアカウントへの入金は、必ずお客様自身のゲームプレイに対応するものでなければなりません。アカウントの不正利用を確認した場合、当サイトはその裁量により、アカウントを閉鎖し、アカウント内の報酬および残高を没収することができます。不正利用には、出金を申請する前に入金額を賭けていない場合その他の不正な利用が含まれますが、これらに限られません。
        </p>
        <h4 class="terms-subtitle">
          4.2&#12288;無料ベット、ボーナスおよびイベント
        </h4>
        <p class="terms-clause">
          4.2.1&#12288;無料ベットまたはボーナスは、イベントもしくはプロモーションの一環として、お客様のアカウントに付与される場合があります。無料ベットおよびボーナスは当サイト内で使用する必要があり、そのまま出金することはできません。ただし、各イベントまたはプロモーションに定める条件を満たした場合、現金ウォレットの出金可能残高へ変換できることがあります。すべてのイベントおよびプロモーションには、各プロモーションの規約および本規約・プロモーション一般利用規約が適用されます。詳細は、各プロモーションの規約およびプロモーション一般利用規約を確認してください。
        </p>
        <h4 class="terms-subtitle">
          4.3&#12288;金融機関、振込、アカウント残高および処理時間
        </h4>
        <p class="terms-clause">
          4.3.1&#12288;アカウントへの入出金は、金融機関または決済サービスプロバイダーを通じて行います。入出金の手順、利用条件、利用可否、手数料および処理時間は、利用する金融機関または決済サービスプロバイダーにより異なる場合があります。
        </p>
        <p class="terms-clause">
          4.3.2&#12288;お客様が入金を行う場合は、各入金申請時に当サイトが指定する口座へ振り込むものとします。過去の入金履歴等を参照して、申請時に指定されていない口座へ誤って振り込んだ場合、当該資金の着金確認、追跡または返金ができないことがあります。この場合、資金の未反映、紛失または返金不能について、当サイトは一切の責任を負いません。
        </p>
        <p class="terms-clause">
          4.3.3&#12288;お客様は、アカウントに十分な資金を維持し、その残高の範囲内でのみベットを行うものとします。アカウント残高を超えるベットは認められず、残高不足にもかかわらず誤って受け付けられたベットについては、当サイトはこれを取り消し、または無効とすることができます。また、決済機関または決済サービスプロバイダーによる入金の取消しにより資金が不足した場合、当サイトは、受付済みのベットを遡って無効とし、当該ベットに関してお客様へ支払った資金の返還を求めることができます。
        </p>
        <p class="terms-clause">
          4.3.4&#12288;本人確認（KYC）が完了している場合、出金の承認は原則として数分程度で完了します。ただし、ゲームプロバイダーによる確認、提携決済会社のメンテナンス、またはお客様の受取先口座のメンテナンス等により、処理に時間を要する場合があります。
        </p>
        <h4 class="terms-subtitle">
          4.4&#12288;仮想通貨による入出金
        </h4>
        <p class="terms-clause">
          4.4.1&#12288;お客様は、自ら管理する仮想通貨ウォレットから当サイトが指定するアドレスへ資金を送金することにより、当サイトのアカウントへ入金できます。
        </p>
        <p class="terms-clause">
          4.4.2&#12288;誤った仮想通貨、ネットワークまたはウォレットアドレスへ送金した資金は、回収できない場合があります。当サイトは、当該資金について一切の責任を負いません。送金前に、通貨、ネットワークおよびアドレスが正しいことを必ず確認してください。
        </p>
        <p class="terms-clause">
          4.4.3&#12288;仮想通貨による入金に必要な情報は、当サイトの「入金」ページに表示します。送金前に、当該情報を十分に確認してください。
        </p>
        <p class="terms-clause">
          4.4.4&#12288;当サイトは、仮想通貨による入出金を希望するお客様に対し、追加の本人確認（KYC）およびセキュリティ審査を行うことができます。疑わしい取引を確認した場合、当サイトは、アカウントを一時停止し、追加の本人確認、資金源の確認その他必要な審査への協力を求めることができます。
        </p>
        <p class="terms-clause">
          4.4.5&#12288;当サイトが本人確認（KYC）またはセキュリティ審査に関する追加情報の提供を求めた場合、お客様は、当該通知から24時間以内に対応しなければなりません。期限内に対応しない場合、当サイトは、アカウントを一時停止し、または出金を保留することができます。
        </p>

        <h3 class="terms-title">
          5.&#12288;サービス、ゲーム運営および技術上のリスク
        </h3>
        <h4 class="terms-subtitle">
          5.1&#12288;娯楽目的およびサービスの変更
        </h4>
        <p class="terms-clause">
          5.1.1&#12288;当サイトのサービスは、娯楽のみを目的として提供されます。サービスの利用は任意であり、お客様は、自らの判断と責任により利用の可否を決定するものとします。お客様は、自己名義で、自己の娯楽および楽しみの目的に限りサービスを利用しなければなりません。当サイトは、これらの目的以外でサービスを利用することを禁止します。
        </p>
        <p class="terms-clause">
          5.1.2&#12288;当サイトは、事前の通知なく、その裁量により、当サイト、一部のゲームまたはその他のサービスを一時停止し、変更し、削除し、もしくは追加し、またはこれらを一時的もしくは恒久的に利用停止とすることができます。これによりお客様に生じた損失について、当サイトは一切の責任を負いません。
        </p>
        <h4 class="terms-subtitle">
          5.2&#12288;ゲームの中断、エラー、技術上の問題および免責
        </h4>
        <p class="terms-clause">
          5.2.1&#12288;承認済みのゲームラウンドが何らかの理由で中断または終了した場合、すべてのお客様の取引は正確に記録され、ゲームの再開時に、未完了のゲームラウンドは中断時点から再開されます。復旧できない場合、当サイトは当該ゲームラウンドを削除し、お客様のアカウントへ賭け金を返金します。
        </p>
        <p class="terms-clause">
          5.2.2&#12288;当サイトの管理が及ばない事由によりサービスを正常に提供できない場合（予期しない技術上の問題または第三者事業者に起因する技術上の問題が発生した場合を含みます）、当サイトは賭けを取り消し、または賭け金を返金することがあります。また、お客様のコンピューターもしくはモバイル端末の性能、またはネットワーク接続が、当サイトの性能および操作に影響する場合があります。当サイトは、お客様の機器、ネットワーク接続または第三者プロバイダーに起因する不具合もしくは問題について責任を負いません。これには、ゲームをプレイできない場合、または特定のゲームに関する情報を表示もしくは受信できない場合が含まれます。
        </p>
        <p class="terms-clause">
          5.2.3&#12288;当サイトは、当サイトおよび当サイトが提供するゲームが完全かつエラーなく機能すること、またはこれらへ中断なくアクセスできることを保証しません。
        </p>
        <p class="terms-clause">
          5.2.4&#12288;お客様は、ゲームの進行、表示、結果、配当、賭け金、勝利金もしくはアカウント残高への反映その他ゲームに関するエラー、不具合または不一致を発見した場合、当サイトによる調査および修正が可能となるよう、直ちにカスタマーサービスへ連絡し、当サイトが求める情報および資料を提出しなければなりません。当該申告は、当該エラーまたは不具合が発生した時から24時間以内に行わなければなりません。当該期間の経過後に行われた申告については、法令上対応が義務付けられる場合を除き、当サイトはこれを受け付けず、調査、ゲーム結果もしくは残高の修正もしくは再計算、賭け金の返金またはその他の補償を一切行いません。
        </p>

        <h3 class="terms-title">
          6.&#12288;知的財産権、宣伝利用および利用制限
        </h3>
        <h4 class="terms-subtitle">
          6.1&#12288;知的財産権の帰属
        </h4>
        <p class="terms-clause">
          6.1.1&#12288;当サイトに関するすべての知的財産権は、当サイトまたは第三者のソフトウェア事業者に帰属します。当サイトの利用により、お客様が当サイトまたはソフトウェア事業者の知的財産権を取得することはありません。知的財産権には、特許権、著作権、意匠権、商標権、データベース権およびこれらに関する出願、ならびに著作者人格権、ノウハウ、営業秘密、機密情報、ドメイン名、URL、商号その他の知的財産権およびこれらに関するライセンスが含まれますが、これらに限られません。これらの権利は、登録の有無、登録可能性、国または地域を問いません。
        </p>
        <h4 class="terms-subtitle">
          6.2&#12288;ソフトウェアおよび当サイトに関する禁止行為
        </h4>
        <p class="terms-clause">
          6.2.1&#12288;お客様は、適用法令の範囲内において、次の行為を行ってはなりません。
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(a)&#12288;ソフトウェアまたは当サイトをコピー、配布、公開、リバースエンジニアリング、逆コンパイル、逆アセンブル、変更、変換、翻訳その他の方法でデコードし、またはソースコードを取得して二次的著作物を作成しようとする行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(b)&#12288;ソフトウェア、当サイトまたはその一部から、著作権、所有権その他の権利表示を削除する行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(c)&#12288;ソフトウェアを販売、譲渡、サブライセンス、頒布または賃貸する行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(d)&#12288;コンピューターネットワークその他の手段を通じて、ソフトウェアを第三者に提供する行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(e)&#12288;物理的または電子的な方法により、ソフトウェアをいずれかの国へ輸出する行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(f)&#12288;適用される法令または規制により禁止された方法で、ソフトウェアを使用する行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(g)&#12288;知的財産権を侵害し、もしくは侵害するおそれのある行為、または運営会社、その従業員、取締役、役員もしくはコンサルタントの信用もしくは評判を損なう行為
        </p>
        <p class="terms-clause terms-clause-item">
          6.2.1(h)&#12288;本規約において明示的に許可されていない方法で、ソフトウェア、当サイトまたはその一部を使用する行為
        </p>
        <h4 class="terms-subtitle">
          6.3&#12288;プレイヤー名、画像および宣伝利用
        </h4>
        <p class="terms-clause">
          6.3.1&#12288;お客様は、当サイトまたはゲーム内で使用するプレイヤー名および画像（プレイヤーのアカウント等を含みます）が、第三者の知的財産権、プライバシー権その他の権利を侵害せず、かつ他人に不快感を与えないものであることを保証します。また、お客様は、当サイトのプライバシーポリシーに従い、当サイトまたはゲームに関連するあらゆる目的で当該名称および画像を使用するための、取消不能、譲渡可能、ロイヤルティフリーかつサブライセンス可能な権利を当サイトに付与します。
        </p>
        <p class="terms-clause">
          6.3.2&#12288;お客様が当サイトを通じて勝利金を獲得した場合、お客様は、当サイトが宣伝およびプロモーションの目的でお客様のアカウント名を使用することに同意したものとみなします。
        </p>

        <h3 class="terms-title">
          7.&#12288;カスタマーサービス、ご意見およびお問い合わせ
        </h3>
        <h4 class="terms-subtitle">
          7.1&#12288;連絡方法、受付期限および内部対応
        </h4>
        <p class="terms-clause">
          7.1.1&#12288;当サイトのサービスに関する意見または問い合わせは、当サイトの案内に従ってカスタマーサービスチームへ連絡するか、support@katsuwin.ai 宛てにメールで送信してください。特定のゲームに関する問題、意見または問い合わせは、問題の発生から24時間以内に行う必要があります。対象には、支払い、アカウントの停止およびボーナスの計算に関する事項が含まれますが、これらに限られません。
        </p>
        <p class="terms-clause">
          7.1.2&#12288;その他の事項に関する意見または問い合わせは、問題の発生から1か月以内に行う必要があります。すべての意見および問い合わせは、カスタマーサービスチームが対応します。
        </p>
        <p class="terms-clause">
          7.1.3&#12288;カスタマーサービススタッフが直ちに解決できないお問い合わせは、当サイトの内部担当者が対応します。当サイトは、お客様に対応状況を適切に通知し、通常14営業日以内の解決に向けて最善を尽くします。
        </p>

        <h3 class="terms-title">
          8.&#12288;アカウントの閉鎖、停止および法的責任
        </h3>
        <h4 class="terms-subtitle">
          8.1&#12288;お客様によるアカウント閉鎖
        </h4>
        <p class="terms-clause">
          8.1.1&#12288;お客様は、カスタマーサービスへ連絡することにより、いつでもアカウントを閉鎖し、利用可能な残高を出金できます。
        </p>
        <p class="terms-clause">
          8.1.2&#12288;アカウント残高がマイナスである場合、お客様は、直ちに不足額を当サイトへ支払うための手続を行わなければなりません。アカウントは、不足額が全額精算された後に限り閉鎖されます。
        </p>
        <p class="terms-clause">
          8.1.3&#12288;アカウントの閉鎖時に未決済の賭けがある場合、当該賭けは引き続き有効とします。ただし、本規約に基づき取り消され、または無効とされる場合を除きます。お客様は、当サイトに連絡することにより、当該賭けから生じた勝利金を受け取ることができます。ただし、当サイトが本規約に基づき勝利金の全部または一部を留保する権利を行使する場合は、この限りではありません。
        </p>
        <h4 class="terms-subtitle">
          8.2&#12288;当サイトによるアカウントの停止または終了
        </h4>
        <p class="terms-clause">
          8.2.1&#12288;次のいずれかの事由が生じた場合、当サイトは、理由を説明することなく、アカウントを一時停止し、もしくは終了し、お客様が行った賭けを取り消し、アカウントから勝利金を削除し、または当サイトが適切と判断するその他の措置を講じることができます。
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(a)&#12288;お客様との取引関係を継続することが、当サイトのライセンス上もしくは規制上の義務、またはサービスに悪影響を及ぼす可能性があると当サイトが判断した場合
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(b)&#12288;お客様が当サイトにおいて、違法行為または詐欺行為に該当する行為を行った場合
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(c)&#12288;お客様が禁止地域に居住している場合、または禁止地域において当サイトのゲームを利用した場合
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(d)&#12288;お客様が本規約に違反した場合
        </p>
        <p class="terms-clause terms-clause-item">
          8.2.1(e)&#12288;法令または当サイトの第三者ライセンサーにより、当サイトが措置を講じるよう命じられた場合
        </p>
        <p class="terms-clause">
          8.2.2&#12288;本規約8.2.1に定める事由によりアカウントを終了する場合、お客様が本規約および関連規則を遵守している限り、当サイトは、その時点でお客様が保有する正当なアカウント残高を返金します。
        </p>
        <h4 class="terms-subtitle">
          8.3&#12288;免責および法的措置
        </h4>
        <p class="terms-clause">
          8.3.1&#12288;適用法令で認められる最大限の範囲において、当サイトは、お客様に対して一切の責任を負いません。
        </p>
        <p class="terms-clause">
          8.3.2&#12288;前項は、当サイトが必要に応じ、適切な状況においてお客様に対して法的措置を講じる権利を制限するものではありません。
        </p>
      </div>
    <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import { mapGetters } from 'vuex'

export default {
  name: 'TermsGold',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    ...mapGetters(['currentTheme']),
    footerIframe() {
      return 'https://katsuwin.info/iframe/term-of-service'
    },
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    },
    brandName() {
      const themeMap = {
        theme_gold: '勝WIN',
        theme_blue: 'Ubet88',
        theme_purple: 'Jack Rabbit Apex'
      }

      return themeMap[this.currentTheme] || '勝WIN'
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
/* 條款結構：章（terms-title）／節（terms-subtitle）／條（terms-clause）／款（terms-clause-item） */
.update-time + .terms-title {
  margin-top: 0;
}
.terms-title {
  margin: 2.5rem 0 1rem;
  font-size: 1.25rem;
  font-weight: 700;
}
.terms-subtitle {
  margin: 1.5rem 0 0.75rem;
  font-size: 1rem;
  font-weight: 700;
}
.terms-clause {
  margin: 0 0 1rem;
  font-size: 1rem;
  line-height: 2;
}
.terms-clause-item {
  padding-left: 1.5em;
}
</style>
